import { animate, state, style, transition, trigger } from "@angular/animations";
import { Component, OnInit, inject } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { IQuickscanData } from "../../../../types/quickscan";
import { ConfigurationService } from "../../../services/configuration.service";

@Component({
  selector: "app-quickscan-table",
  templateUrl: "./quickscan-table.component.html",
  styleUrls: ["./quickscan-table.component.less"],
  imports: [MatTableModule, MatIconModule],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition("expanded <=> collapsed", animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")),
    ]),
  ],
})
export class QuickscanTableComponent implements OnInit {
  public dataSource: MatTableDataSource<IQuickscanData> = new MatTableDataSource();
  public options: Record<string, string> = {
    year: "numeric",
    month: "short",
    day: "numeric",
    weekday: "long",
  };
  public columnsToDisplay = [
    "_ts",
    "GovernmentalInstitution",
    "EmailAdress",
    "ProjectName",
    "ProjectDuration",
    "YearOfImplementation",
    "ProjectDescription",
  ];
  public columnTitles: { [key: string]: string } = {
    _ts: "Datum",
    EmailAdress: "Email Adres",
    GovernmentalInstitution: "Klant",
    ProjectDescription: "Beschrijving",
    ProjectDuration: "Duur",
    ProjectName: "Projectnaam",
    YearOfImplementation: "Jaar van uitvoering",
  };
  public columnsToDisplayWithExpand = [...this.columnsToDisplay, "expand"];
  public expandedElement: IQuickscanData | null;

  public config: ConfigurationService;

  public constructor() {
    this.config = inject(ConfigurationService);
    this.expandedElement = null;
  }

  public ngOnInit(): void {
    this.config.quickScansChanged.subscribe(() => {
      this.setDataSourceData();
    });
  }

  public setDataSourceData(): void {
    this.dataSource.data = this.config.quickScans.map((record) => {
      return {
        ...record,
        _ts: typeof record._ts === "string" ? record._ts : this.convertDate(record._ts * 1000),
      };
    });
  }

  public convertDate(date: number): string {
    return new Date(date).toLocaleDateString("nl-NL", this.options);
  }
}
